export class ActionFailedError extends Error {
  constructor(message: string = "Action failed") {
    super(message);
    this.name = "ActionFailedError";
  }
}
